








































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { VatsApi, Vat, GraphsApi, NotificationsApi } from '../../api';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import moment from 'moment';

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);

@Component({
	components: {},
	props: {
		productId: Number,
		entityType: String | null,
		entityId: Number | null,
	},
})
export default class Notifications extends Vue {
	public productId: number | undefined;
	public entityId: number | undefined;
	public entityType: number | undefined;

	public dateForm = {
		start: moment()
			.subtract(30, 'days')
			.locale('en-nz')
			.format('DD-MM-YYYY hh:mm:ss')
			.toString(),
		end: moment()
			.locale('en-nz')
			.format('DD-MM-YYYY hh:mm:ss')
			.toString(),
		shortcut: null,
	};

	public notifications = [];

	public notificationFields = [
		{ key: 'created_at', label: 'Date' },
		{ key: 'data.eventTypeName', label: 'Event Type' },
		{ key: 'data.channel', label: 'Channel' }, // maybe should be channel instead of data.channel. Steve raised a bug regarding this
		{ key: 'userName', label: 'Name' },
		{ key: 'userEmail', label: 'Email' },
		{ key: 'userPhone', label: 'Phone' },
	];

	public created() {
		this.updateForm();
	}

	public updateForm() {
		if (this.dateForm.end === null || this.dateForm.start === null) {
			return;
		}
		this.notificationData();
	}

	public async notificationData() {
		try {
			const { data } = await new NotificationsApi().getNotificationsSentBetween(
				parseInt(this.productId, 10),
				{
					startTs: moment(this.dateForm.start, 'DD/MM/YYYY hh:mm:ss')
						.startOf('day')
						.format('X'),
					endTs: moment(this.dateForm.end, 'DD/MM/YYYY hh:mm:ss')
						.endOf('day')
						.format('X'),
				},
			);
			this.notifications = data.data.map(notification => {
				return { ...notification, data: JSON.parse(notification.data) };
			});
			if (this.entityType && this.entityId) {
				this.notifications = this.notifications.filter(
					notification =>
						notification.data.entityType === this.entityType &&
						notification.data.entityId == this.entityId,
				);
			}
		} catch (e) {
			console.log(e);
		} finally {
			// console.log('done');
		}
	}
}
